import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { AtsHiringStageNamesEnum } from 'generated/resources/graphql'

import { isNew } from 'modules/ats/lib/utils/hiringStages'

interface Props {
  stageName: AtsHiringStageNamesEnum
  stageLabel: string
}

export const NonEditableStage = ({ stageName, stageLabel }: Props) => {
  const icon = isNew(stageName) ? 'inbox' : 'check-circle'
  const topBorderColor = isNew(stageName) ? 'lime1000' : 'malibu1000'

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
      padding={'s16'}
      background="grey100"
      border={{
        all: { color: 'grey400', style: 'solid', width: 's1' },
        top: { color: topBorderColor, style: 'solid', width: 's4' },
      }}
    >
      <Box flexDirection="row" gap={'s4'}>
        <Icon.Medium icon={icon} color="grey800" />
        <Text.Normal weight="medium" color="grey800">
          {stageLabel}
        </Text.Normal>
      </Box>
      <Icon.Medium icon="info-circle-line" color="grey800" />
    </Box>
  )
}
